import { RowNode } from '@ag-grid-community/core';
import { generateUUID } from '@thoughtspot/js-util';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Button } from '../../../../button';
import styles from './hover-action-cell.module.scss';
export const HoverActionCell = ({ context, data, node, }) => {
    const getMappedRowActionItems = () => {
        if (!context.rowActionItems) {
            return [];
        }
        const rowActionItems = _.isFunction(context.rowActionItems)
            ? context.rowActionItems(data)
            : context.rowActionItems;
        return rowActionItems.map(({ icon, label, id, onClick }) => ({
            icon,
            label,
            id,
            onClick: (event) => {
                onClick(event, data);
            },
        }));
    };
    const rowActionItems = getMappedRowActionItems();
    const [isHovering, setIsHovering] = useState(false);
    const showRow = () => setIsHovering(true);
    const hideRow = () => setIsHovering(false);
    useEffect(() => {
        node.addEventListener(RowNode.EVENT_MOUSE_ENTER, showRow);
        node.addEventListener(RowNode.EVENT_MOUSE_LEAVE, hideRow);
        return () => {
            node.removeEventListener(RowNode.EVENT_MOUSE_ENTER, showRow);
            node.removeEventListener(RowNode.EVENT_MOUSE_LEAVE, hideRow);
        };
    });
    return (React.createElement("div", { className: styles.hoverCellContainer }, isHovering &&
        rowActionItems.length > 0 &&
        rowActionItems.map(({ onClick, icon, label }) => (React.createElement("div", { key: generateUUID(), className: styles.actionButton },
            React.createElement(Button, { onClick: onClick, icon: icon, text: label, type: "secondary", size: "m", ariaLabel: label, "data-tooltip-content": label }))))));
};
//# sourceMappingURL=hover-action-cell.js.map